import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { CurrentUser } from '../models/current-user.model';
import { AuthenticationService } from "./authentication.service";
import { OfficeService } from "./office.service";
import { ProcessLoadingService } from "./loading.service";
import { MapService } from "./map.service";
import { ROUTE_PATH } from '../constants/route-path';
import { LoginHelper } from '../_helper/login.helper';
import { SessionStorageKey } from "../constants/session-storage-key";
import { FloorInfoService } from "./floorinfo.service";

@Injectable({ providedIn: 'root' })
export class LoginFlowService {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private officeService: OfficeService,
    private pageLoadingService: ProcessLoadingService,
    private mapService: MapService,
    private floorInfoService: FloorInfoService
  ) { }

  async handleLoginSuccess(userInfo: CurrentUser): Promise<boolean> {
    this.authService.setCurrentUser({ ...userInfo});

    // Validate user has companies
    if (!userInfo.listcompany || userInfo.listcompany.length === 0) {
      return false;
    }

    const uniqueOrg = Array.from(
      new Map(userInfo.listcompany.map(item => [item.organizationId, item])).values()
    );

    // If user belongs to only one organization
    if (uniqueOrg && uniqueOrg.length === 1) {
      return await this.handleOneOrg(userInfo);
    }

    // If user belongs to multiple organizations
    this.authService.setListCompany(userInfo.listcompany || []);
    sessionStorage.setItem(SessionStorageKey.ORGANIZATION, JSON.stringify(userInfo.listcompany))
    this.router.navigate([ROUTE_PATH.CHOOSE_ORG]);
    return true;
  }

  async handleOneOrg(userInfo: CurrentUser): Promise<boolean> {
    if (!userInfo.listcompany || userInfo.listcompany.length === 0) {
      return false;
    }

    this.pageLoadingService.showLoading();
    let isSuccess = false;

    try {
      isSuccess = await LoginHelper.loginOrg(
        this.authService,
        this.officeService,
        this.mapService,
        this.floorInfoService,
        this.router,
        userInfo,
        userInfo.listcompany[0]
      );
    } catch (err) {
      console.error('Error in handleOneOrg:', err);
      isSuccess = false;
    } finally {
      this.pageLoadingService.hideLoading();
    }
    
    return isSuccess;
  }
    
}